"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.typographyStyles = exports["default"] = void 0;
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var React = _interopRequireWildcard(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _constants = require("../constants");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
var defaultHeading = "\n  ".concat((0, _constants.fontWeight)('heavy'), ";\n  color: ").concat(_constants.colors.darkestGrey, ";\n  font-family: Untitled Sans, sans-serif;\n");
var typographyStyles = {
  p: function p(props) {
    return {
      'font-family': 'Untitled Sans, sans-serif',
      'font-size': '14px',
      // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type '{ (amount: FontWeight): string; light: number; normal: number; heavy: number; heaviest: number; }'.
      'font-weight': _constants.fontWeight[props.fontWeight] || _constants.fontWeight.normal,
      'line-height': '20px',
      color: props.color === 'grey' ? _constants.colors.mediumGrey : _constants.colors.darkestGrey,
      'margin-bottom': props.spaced ? '20px' : 'initial',
      'margin-top': props.marginTop || 0
    };
  },
  h1: defaultHeading.concat("\n    font-size: 22px;\n    line-height: 30px;\n    ".concat((0, _constants.fontWeight)('normal'), ";\n  ")),
  h2: defaultHeading.concat("\n    font-size: 20px;\n    line-height: 28px;\n  "),
  h3: defaultHeading.concat("\n    font-size: 16px;\n    line-height: 24px;\n  "),
  h4: defaultHeading.concat("\n    font-size: 14px;\n    line-height: 22px;\n  "),
  h5: defaultHeading.concat("\n    font-size: 12px;\n    line-height: 20px;\n  "),
  strong: "\n    font-family: Untitled Sans, sans-serif;\n    font-size: 14px;\n    ".concat((0, _constants.fontWeight)('heavy'), ";\n    color: ").concat(_constants.colors.darkestGrey, ";\n  "),
  em: "\n    font-family: Untitled Sans, sans-serif;\n    font-size: 14px;\n    color: ".concat(_constants.colors.mediumGrey, ";\n  "),
  a: "\n    font-family: Untitled Sans, sans-serif;\n    font-size: 14px;\n    line-height: 24px;\n    text-decoration: none;\n    color: ".concat(_constants.colors.mediumBlue, ";\n  ")
};
exports.typographyStyles = typographyStyles;
var Typography = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2["default"])(Typography, _React$Component);
  var _super = _createSuper(Typography);
  function Typography(props) {
    var _this;
    (0, _classCallCheck2["default"])(this, Typography);
    _this = _super.call(this, props);
    _this.element = void 0;
    var type = _this.props.type;

    // @ts-expect-error - TS2322 - Type 'StyledComponent<"em" | "h1" | "h2" | "h3" | "h4" | "h5" | "p" | "strong", DefaultTheme, {}, never>' is not assignable to type 'AbstractComponent<Record<any, any>, Props>'. | TS2769 - No overload matches this call.
    _this.element = (0, _styledComponents["default"])(type).withConfig({
      displayName: "typography__element"
    })([], typographyStyles[type]);
    return _this;
  }
  (0, _createClass2["default"])(Typography, [{
    key: "render",
    value: function render() {
      var StyledElement = this.element;
      return /*#__PURE__*/React.createElement(StyledElement, this.props, this.props.children);
    }
  }]);
  return Typography;
}(React.Component);
exports["default"] = Typography;
Typography.defaultProps = {
  marginTop: 0,
  fontWeight: ''
};